import PopularStrainsSection from "./PopularStrainsSection";

export default PopularStrainsSection;
